import { RoundButton } from '@/components/buttons/Buttons';
import React from 'react';

type Props = {
	formName?: string;
	id: string;
	onClickCancel: () => void;
	onClickSave: () => void;
	saveLabel?: string;
};

const FooterContent = (props: Props) => {
	return (
		<div>
			<RoundButton
				className="tc-text-button"
				formName={props.formName ?? ''}
				id={`${props.id}-cancel"`}
				label="Cancel"
				onClick={props.onClickCancel}
			/>
			<RoundButton
				formName={props.formName ?? ''}
				id={`${props.id}-add`}
				label={props.saveLabel ?? 'Save Changes'}
				onClick={props.onClickSave}
			/>
		</div>
	);
};

export default React.memo(FooterContent);
